<script setup>
import { computed, defineProps } from 'vue';

    const props = defineProps({
        text: String, // The contents of the tip.
        position: {
            // The side the tooltip should appear on.
            // top, bottom, left, right
            type: String,
            default: "top",
        },
        disabled: {
            // Disable showing the tooltip text on hover (for conditionals)
            type: Boolean,
            default: false,
        },
    })

    const positioningClasses = computed(()=>{
        let classes = [];

        // X or Y direction
        if (props.position == "top" || props.position == "bottom") {
            classes = classes.concat([
            "left-1/2",
            "after:left-1/2",
            "after:border-x-transparent",
            "-ml-[65px]",
            "after:-ml-[5px]",
            ]);
        } else if (props.position == "left" || props.position == "right") {
            // Unlike the perfectly-centerable box+arrow on the vertical positions, the horizontal ones will start at the same Y-position as the <slot> item and continue down the page, leaving the arrow near the top for longer boxes.
            classes = classes.concat([
                "top-1/2",
                "min-h-[3rem]",
                "after:top-[1.5rem]",
                "after:border-y-transparent",
                "-mt-[1.5rem]",
                "after:-mt-[5px]",
            ]);
        }

        // Direction specific
        if (props.position == "top") {
            classes = classes.concat([
            "bottom-[125%]",
            "top-[unset]",
            "after:top-full",
            "after:border-b-transparent",
            ]);
        } else if (props.position == "bottom") {
            classes = classes.concat([
            "top-[125%]",
            "bottom-[unset]",
            "after:bottom-full",
            "after:border-t-transparent",
            ]);
        } else if (props.position == "left") {
            classes = classes.concat([
            "right-[125%]",
            "left-[unset]",
            "after:left-full",
            "after:border-r-transparent",
            ]);
        } else if (props.position == "right") {
            classes = classes.concat([
            "left-[125%]",
            "right-[unset]",
            "after:right-full",
            "after:border-l-transparent",
            ]);
        }

        return classes.join(" ");
    });
</script>
<template>
    <span class="group/tooltip relative inline">
        <slot>
            <div
                :class="[
                    'inline-flex align-middle items-center px-2 rounded cursor-help',
                    'text-neutral-500 group-hover/hiddenmenu:text-white group-hover/hiddenmenu:bg-neutral-500'
                ]"
            >
                <svg class="w-6 h-auto" xmlns="http://www.w3.org/2000/svg" height="160" width="160" viewBox="0 0 160 160" version="1.0">
                    <g fill="currentColor">
                        <path d="m80 15c-35.88 0-65 29.12-65 65s29.12 65 65 65 65-29.12 65-65-29.12-65-65-65zm0 10c30.36 0 55 24.64 55 55s-24.64 55-55 55-55-24.64-55-55 24.64-55 55-55z"/>
                        <path d="m57.373 18.231a9.3834 9.1153 0 1 1 -18.767 0 9.3834 9.1153 0 1 1 18.767 0z" transform="matrix(1.1989 0 0 1.2342 21.214 28.75)"/>
                        <path d="m90.665 110.96c-0.069 2.73 1.211 3.5 4.327 3.82l5.008 0.1v5.12h-39.073v-5.12l5.503-0.1c3.291-0.1 4.082-1.38 4.327-3.82v-30.813c0.035-4.879-6.296-4.113-10.757-3.968v-5.074l30.665-1.105"/>
                    </g>
                </svg>
            </div>
        </slot>
        <span
        :class="[
            'absolute z-10 p-2 w-32 rounded bg-neutral-500 shadow',
            'flex items-center',
            'text-xs font-normal text-white text-center',
            'invisible',
            !disabled ? 'group-hover/tooltip:visible' : '',
            'after:absolute after:content-[\'\'] after:border-[5px] after:border-neutral-500',
            positioningClasses,
        ]"
        >
        <div class="grow">
            {{ text }}
        </div>
    </span>
</span>
</template>
